import { Utility } from './../../../../../shared/utility';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RowArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';

@Component({
  selector: 'app-valid-detail-view',
  templateUrl: './valid-detail-view.component.html',
  styleUrls: ['./valid-detail-view.component.css']
})
export class ValidDetailViewComponent implements OnInit {
  isDisabled: boolean;
  operators: any;
  config: any;
  isRowSelected: (e: RowArgs) => boolean;
  selectedData = [];
  gridData = [];
  loading: boolean;
  adjustmentId: any;
  selectedSSN: any;
  enableChildDeleteBtn: boolean;
  deleteRecordDialog: boolean;
  reasonCodesList: any;
  isClicked = false;
  adjRecord: any;
  gridState: State = {
    sort: [],
    take: 10,
    skip: 0
  };
  @Input()
  set accessOperators(value: any) {
    if (value) {
      this.operators = value;
    }
  }
  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.adjustmentId = dataItem.payrollAdjustmentsId;
      this.selectedSSN = dataItem.ssn;
      this.getAdjustmentV2Details(dataItem);
    }
  }
  @Input() set adjustmentInputs(inputData: any) {
    if (inputData) {
      const newArray = inputData.reasonCodes.map(item => ({
        ...item,
        reasonCode: item.id + '-' + item.reason
      }));
      this.reasonCodesList = newArray;
    }
  }
  @Input()
  set disableChild(value: boolean) {
    this.isDisabled = value;
  }
  @Output() editAction: EventEmitter<any> = new EventEmitter();
  @Output() childDeletedRecord: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    this.config = this.readConfigService.getAdjustmentv2Text();
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
  }

  getAdjustmentV2Details(dataItem: any) {
    this.notificationService.setUpLoading(true);
    const inputData = {
      userInfo: this.usersService.UserInfo(), ssn: this.usersService.encrypt(dataItem.ssn, 'post'), adjustmentId: dataItem.payrollAdjustmentsId,
      adjustmentType: 'validated'
    };
    this.adjustmentService.getAdjustmentV2Details(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        if (response.adjustmentsBySsn && response.adjustmentsBySsn.length > 0) {
          response.adjustmentsBySsn.forEach((element: any) => {
            element.payPeriodEndDate = new Date(element.payPeriodEndDate);
            element.payPeriodBeginningDate = new Date(element.payPeriodBeginningDate);
            element.formatAmount = Utility.checkNegativeAmount(element.employeeContribution);
            element.lastFourSSN = element.ssn.substr(5);
            element.payrollType = 'Adjustment'
          });
          this.gridData = response.adjustmentsBySsn;
        } else {
          this.gridData = [];
        }
      } else if (response && response.statusCode === 204) {
        this.gridData = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  onSelectionChange(event: any) {
    if (this.selectedData.length === 0 && event.ctrlKey === undefined) {
      if (event.selectedRows.length > 0) {
        this.selectedData = [];
        event.selectedRows.filter((element: any) => this.selectedData.push(element.dataItem));
      } else if (event.deselectedRows.length > 0) {
        this.selectedData = [];
      }
    } else {
      if (event.selectedRows.length > 0) {
        if (event.selectedRows.length > 1) {
          event.selectedRows.filter((element: any) => this.selectedData.push(element.dataItem));
        } else if (this.selectedData[0] !== event.selectedRows[0].dataItem) {
          this.selectedData.push(event.selectedRows[0].dataItem);
        }
      } else if (event.deselectedRows.length > 0) {
        if (event.deselectedRows.length > 1) {
          event.deselectedRows.filter((element: any) => {
            if (this.selectedData.indexOf(element.dataItem) > -1) {
              const index = this.selectedData.indexOf(element.dataItem);
              this.selectedData.splice(index, 1);
            }
          });
        } else {
          const index = this.selectedData.indexOf(event.deselectedRows[0].dataItem);
          this.selectedData.splice(index, 1);
        }
      }
    }
    this.isRowSelected = (e: RowArgs) => this.selectedData.indexOf(e.dataItem) >= 0;
    this.enableChildDeleteBtn = this.selectedData && this.selectedData.length > 0;
  }

  deleteRecord() {
    this.loading = true;
    const allAdjRecordIds = this.selectedData.map(x => x.id).join(",")
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      adjustmentId: this.adjustmentId,
      adjRecordIds: allAdjRecordIds
    };
    this.adjustmentService.deleteAdjRecord(inputData).subscribe(response => {
      if (response && response.success) {
        this.deleteRecordDialog = false;
        this.enableChildDeleteBtn = false;
        const dataItem = { payrollAdjustmentsId: this.adjustmentId, ssn: this.selectedSSN };
        this.childDeletedRecord.emit({ payrollAdjustmentsId: dataItem.payrollAdjustmentsId });
        this.notificationService.setUpNotification({ success: true, message: response.message });
      } else {
        this.deleteRecordDialog = false;
        this.notificationService.setErrorNotification();
      }
      this.loading = false;
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
        this.deleteRecordDialog = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  editHandler(data: any) {
    this.editAction.emit({ event: data, isEditClicked: true });
  }

  openRecord(record: any, isClicked: boolean) {
    this.isClicked = isClicked;
    const reasonCodeArray = record.reasonCodes.split(',').map(code => code.trim());
    const array2Integers = reasonCodeArray.map(item => parseInt(item, 10));
    const filteredRecords = this.reasonCodesList.filter(item => array2Integers.includes(item.id));
    this.adjRecord = record;
    this.adjRecord.reasonCodeArray = filteredRecords;
  }

  isDialogClosed(isClosed: boolean) {
    this.isClicked = isClosed;
  }

}
